import { useMediaQuery } from '@material-ui/core'

const breakpoints = {
    xs: 0,
    sm: 600,
    md: 1024,
    lg: 1366,
    xl: 1920,
}

const useBreakpoints = () => {
    return {
        sm: useMediaQuery(`(min-width:${breakpoints.sm}px)`),
        md: useMediaQuery(`(min-width:${breakpoints.md}px)`),
        lg: useMediaQuery(`(min-width:${breakpoints.lg}px)`),
        xl: useMediaQuery(`(min-width:${breakpoints.xl}px)`),
    }
}

export { breakpoints, useBreakpoints }